/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* CommunicationEvents service.
* @module api/CommunicationEventsApi
* @version v0.3
*/
export default class CommunicationEventsApi {

    /**
    * Constructs a new CommunicationEventsApi.
    * @alias module:api/CommunicationEventsApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the communicationEventsGet operation.
     * @callback moduleapi/CommunicationEventsApi~communicationEventsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Communication Events for referred patients
     * @param {String} userId User ID
     * @param {module:api/CommunicationEventsApi~communicationEventsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    communicationEventsGet(userId, callback) {

      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling communicationEventsGet");
      }

      let pathParams = {

      };
      let queryParams = {
        'user_id': userId
      };
      let headerParams = {

      };
      let formParams = {

      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/communication_events', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}